import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  return {
    container: {
      paddingTop: '30px',
      width: '100%',
      height: '100%'
    },
    subContainer: {
      marginTop: '20px',
      position: 'relative',
      paddingRight: '45px',
      '& .downloadFiles': {
        marginBottom: '5px',
      },
    },
     header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '20px',
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      '&.flex-j-e': {
        justifyContent: 'end',
      },
    },
    /* title: {
      flexGrow: 1,
      fontSize: '20px',
      fontWeight: '500',
    }, */
    section: {
      marginBottom: '32px',
    },
    clean: {
      fontSize: '2.4rem',
      color: colors.color4,
      padding: '6px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    hide: {
      visibility: 'hidden',
    }, 

    //Table
    
    headerTable: {
      '&.MuiTableCell-head': {
        minWidth: '200px',
      },
      '&.MuiTableCell-root.MuiTableCell-root': {
        vertialAlign: 'middle',
      },
    },
    headerTableActions: {
      '&.MuiTableCell-head': {
        minWidth: '50px',
      },
      '&.MuiTableCell-root.MuiTableCell-root': {
        vertialAlign: 'middle',
      },
    },
    constainerAction: {
      display: 'flex',
      columnGap: '12px',
    },
    edit: {
      padding: 0,
      color: colors.color4,
    },
    delete: {
      padding: 0,
      color: colors.color19,
    },
    baseMenu: {
      '& .MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper': {
        boxShadow: `1px 1px ${colors.color13}30`,
      },
    },
  }
}

export { useStyles }
